export interface AccessKey {
    access_key: string
    acky_id: number
    acky_name: string
    is_enabled: boolean
}
export interface ObjectToAccessKeyProps {
    access_key: string
    acky_id: number | string
    acky_name: string
    is_enabled: boolean | string
}
export function ObjectToAccessKey(obj: ObjectToAccessKeyProps): AccessKey {
    return {
        access_key: obj.access_key,
        acky_id: typeof obj.acky_id == "string" ? parseInt(obj.acky_id) : obj.acky_id,
        acky_name: obj.acky_name,
        is_enabled: typeof obj.is_enabled == "string" ? obj.is_enabled == "ENABLED" : obj.is_enabled
    }
}